import script from "./BreadCrumbNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadCrumbNav.vue?vue&type=script&lang=ts&setup=true"

import "./BreadCrumbNav.vue?vue&type=style&index=0&id=61efe9d8&lang=css"

const __exports__ = script;

export default __exports__